import React, { useState } from "react";

export default function SubmissionForm({ projectId }) {
  const [githubUrl, setGithubUrl] = useState("");
  const [file, setFile] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("githubUrl", githubUrl);
    formData.append("file", file);
    formData.append("projectId", projectId);

    // Şimdilik sahte bir istek (gerçek backend yerine)
    try {
      console.log("Form gönderiliyor:", { githubUrl, file, projectId });
      setSubmitted(true);
    } catch (error) {
      console.error("Gönderim hatası:", error);
    }
  };

  return (
    <div className="mt-6 bg-white p-4 rounded shadow">
      <h3 className="text-lg font-semibold mb-2">Proje Teslim Formu</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="GitHub linkiniz"
          value={githubUrl}
          onChange={(e) => setGithubUrl(e.target.value)}
          className="w-full border p-2 rounded"
        />
        <input
          type="file"
          onChange={(e) => setFile(e.target.files[0])}
          className="w-full border p-2 rounded"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          Gönder
        </button>
        {submitted && (
          <p className="text-green-600">Teslim başarıyla yapıldı!</p>
        )}
      </form>
    </div>
  );
}
